export class PushNotification{
    templateId: string;
    data: Object;
    scheduledDateTime: string | null;
    programIds: string[];

    constructor(templateId: string, data: Object, scheduledDateTime: string | null, programIds: string[]){
        this.templateId = templateId;
        this.data = data;
        this.scheduledDateTime = scheduledDateTime;
        this.programIds = programIds;
    }
}